module.exports = __webpack_public_path__ + "static/img/点検依頼.3b70432.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/domain1/点検依頼.png
// module id = dq8p
// module chunks = 0